module.exports = __webpack_public_path__ + "static/media/cashback.89b21dbb.svg";